import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { periodSelector } from '../../store/selectors';
import { setPeriod } from '../../store/actions';
import DateRangePicker from '../../../../components/DateRangePicker/DateRangePicker'

const SelectPeriod = () => {
  const period = useSelector(periodSelector);

  const dispatch = useDispatch()

  const handle = (dates) => {
    const date = Array.isArray(dates) ? dates : dates.range;
    return dispatch(setPeriod(date))
  }

  const defineActiveRange = (dates) => {
    console.log(dates)
        const [currentFromDate, currentToDate] = period;
        const [fromDate, toDate] = dates.range;
    
        return currentFromDate.isSame(fromDate, 'day') && currentToDate.isSame(toDate, 'day');
      };

  return (
    <DateRangePicker
    storedDatesRange={period}
    getDataByRangeAction={handle}
    storedSelectedRange={defineActiveRange}
  />
  );
};

export default SelectPeriod;
